import { useEffect } from "react"

import { useAppState } from "../../context/appStateContext"
import useHasPro from "../../hooks/useHasPro"
import useQueryParams from "../../hooks/useQueryParams"
import useStrings from "../../localization/useStrings"
import images from "../../utils/images"
import native from "../../native/native"
import styles from "./ImportPhotosScreen.module.scss"

const ImportPhotosScreen = () => {
  const strings = useStrings()
  const { state, actions } = useAppState()
  const hasPro = useHasPro()
  const queryParams = useQueryParams()
  const showSkip = hasPro || queryParams.isPremiumUser
  const productDataLoaded = state.productData?.loaded == true

  useEffect(() => {
    actions.setIgnoreHeaderInset(true)
    actions.setIgnoreFooterInset(true)
  }, [actions])

  useEffect(() => {
    if (productDataLoaded) {
      native.logMixpanelEvent("onboarding_import_shown", { type: "html" })
    }
  }, [productDataLoaded])

  const handleAddToVault = () => {
    native.postNativeEvent("importPhotos")
  }

  const handleSkip = () => {
    native.postNativeEvent("skip")
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={`${styles.image} ${images.startVault.class}`} />
        <h1 className={styles.title}>{strings.importTitle}</h1>
        <p className={styles.subtitle}>{strings.importInfo}</p>
        <button onClick={handleAddToVault} className={styles.ctaButton}>
          <svg
            className={styles.plusIcon}
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 2V18"
              stroke="white"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2 10H18"
              stroke="white"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {strings.importCTA}
        </button>
        {showSkip && (
          <button onClick={handleSkip} className={styles.skipButton}>
            {strings.skip}
          </button>
        )}
      </div>
    </div>
  )
}

export default ImportPhotosScreen
